module.exports = __webpack_public_path__ + "static/media/revolut-logo.14a9e986.svg";